import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import CaseHero from "./app/CaseHero";
import { Login } from "./app/casehero/auth/pages";
import Deposit from "./app/casehero/deposit/pages/Deposit";
import GeneralTenant from "./app/casehero/generalTenant/pages/GeneralTenant";
import Mietendeckel from "./app/casehero/mietendeckel/pages/Mietendeckel";
import Mietminderung from "./app/casehero/mietminderung/pages/Mietminderung";
import Mietpreisbremse from "./app/casehero/mietpreisbremse/pages/Mietpreisbremse";
import Newsletter from "./app/casehero/newsletter/Newsletter";
import OperatingCost from "./app/casehero/operatingCost/pages/OperatingCost";
import Finances from "./app/casehero/settings/components/pages/Finances";
import PartnerSettings from "./app/casehero/settings/components/pages/PartnerSettings";
import Prices from "./app/casehero/settings/components/pages/Prices";
import Settings from "./app/casehero/settings/components/pages/Settings";
import TaskCategories from "./app/casehero/settings/components/TaskCategories/TaskCategories";
import BackdropSpinner from "./app/casehero/shared/components/BackdropSpinner";
import PrivateRoute from "./app/casehero/shared/components/PrivateRoute";

const Home = lazy(() => import("./app/casehero/admin/pages/Home"));
const Users = lazy(() => import("./app/casehero/users/pages/Users"));

const App = () => {
  // TODO:
  // CaseProvider should probably have the login system separated from it
  // Quick attempts at moving it inside the Routes caused CSS issues
  return (
    <Suspense fallback={<BackdropSpinner />}>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <CaseHero />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="users" element={<Users />} />
          <Route path="newsletter" element={<Newsletter />} />
          <Route path="settings">
            <Route index element={<Settings />} />
            <Route path="tasks" element={<TaskCategories />} />
            <Route path="partners" element={<PartnerSettings />} />
            <Route path="finances" element={<Finances />} />
            <Route path="prices" element={<Prices />} />
          </Route>
          <Route path="mietminderung" element={<Mietminderung />} />
          <Route path="mietendeckel" element={<Mietendeckel />} />
          <Route path="mietpreisbremse" element={<Mietpreisbremse />} />
          <Route path="mietrechtsanfragen" element={<GeneralTenant />} />
          <Route path="nebenkosten" element={<OperatingCost />} />
          <Route path="kaution" element={<Deposit />} />
        </Route>
        <Route path="login" element={<Login />} />
        <Route path="error" element={<>Ein Fehler ist aufgetreten.</>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default App;
